import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {CommandService} from '@core/services/command.service';

import {DialogService} from '@shared/services/dialog-service';
import {BasketProvider} from '@shared/models/basket-provider';
import { O } from '@angular/cdk/keycodes';

@Injectable({
  providedIn: 'root',
})
export class CreateDataSurveyCommandHandler  implements IPlatformCommandHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  activatedRoute: ActivatedRoute;
  magicLinkModelValueChanged: EventEmitter<any>;
  unSubscribe$ = new Subject<void>();
  constructor(
    private dialogService: DialogService,
    protected commandService: CommandService
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any) {
    const basketId = BasketProvider.getCurrentBasket().basketKey.toUpperCase();
    const title = `${command.fieldValues['ToolName']}${basketId}`;
    let sourceTypes = command.fieldValues['SourceTypes'];
    if(basketId == '-MX'){
      sourceTypes = sourceTypes.map(o => BasketProvider.getBasketMappedSourceType(o));
      sourceTypes = sourceTypes.filter(o => o !== 'Other-Persons-MX');
    } else {
      sourceTypes = sourceTypes.map(o => convertToEuSourceType(o));
    }
    const parameters = {'SourceTypes': sourceTypes};
    this.dialogService.createOrLoadDefaultSurveyTemplate(title, false, false, null, parameters);
    return true;
  }
}
function convertToEuSourceType(sourceType: string) {
  let updatedSourceType = sourceType.replace("-MX","");
  return updatedSourceType;
}

